import { getShadowRoot, getStoreData, setBrowserDetails, setIpAddress, setSessionData } from "./store";

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/*eslint no-loop-func: "off"*/
export const getErrorHtmlFromResponse = (errorRes) => {
  if (errorRes && errorRes.data) {
    if (errorRes.data.errors && Object.keys(errorRes.data.errors).length) {
      let errorHtml = "<ul>",
        errorFound = false;

      for (const errorKey in errorRes.data.errors) {
        errorRes.data.errors[errorKey].forEach((errorMessage) => {
          errorFound = true;
          errorHtml += `<li> ${errorMessage} </li>`;
        });
      }

      errorHtml += "</ul>";

      if (errorFound) return errorHtml;
    }

    return errorRes.data.message;
  }

  return false;
};

export const setError = (
  error,
  autoCloseOnTimer = false,
  timer = 5000,
  defaultErrorMessage = "Something went wrong. Please try again later."
) => {
  let errorDiv = getShadowRoot().querySelector(
    ".form-content.active div#identity-alert__error"
  );

  if (!errorDiv) return;

  let errorMessage = errorDiv.querySelector(
      ".form-content.active #identity-alert__message"
    ),
    errorDisplay = error;

  if (typeof error === "object" && error !== null) {
    errorDisplay = getErrorHtmlFromResponse(error) || defaultErrorMessage;
  }

  if (!errorMessage) return;

  if (errorDisplay) {
    errorDiv.style.display = "flex";
    errorDiv.style.opacity = 1;
    errorMessage.innerHTML = errorDisplay;

    if (autoCloseOnTimer)
      setTimeout(() => {
        errorDiv.style.display = "none";
        errorDiv.style.opacity = 0;
        errorMessage.innerHTML = "";
      }, timer);
  } else {
    errorDiv.style.display = "none";
    errorDiv.style.opacity = 0;
    errorMessage.innerHTML = "";
  }
};

export const setLoading = (loading = false, changeDisabled = true) => {
  let buttons = getShadowRoot().querySelectorAll(".form-content.active button");

  buttons.forEach((button) => {
    if (!button.classList.contains("skip-loading")) {
      if (changeDisabled) button.disabled = loading;

      if (loading) button.classList.add("identity-btn-loading");
      else button.classList.remove("identity-btn-loading");
    }
  });
};

export const setMainLoader = (loading = false) => {
  let container = getShadowRoot();
  const mainLoader = container.querySelector(`#mainLoader`);
  if (!mainLoader) return;
  const mainLoaderText = container.querySelector(`#dialog-loader-text`);

  mainLoader.style.display = loading ? "flex" : "none";

  let { sessionData } = getStoreData();
  if (mainLoaderText) mainLoaderText.style.display = sessionData && sessionData.appLoaded ? "none" : "flex";
  setSessionData({
    ...sessionData,
    appLoaded: !!loading
  })
};

export const getMaskedEmail = (email) => {
  let skipFirstChars = 3,
    firstThreeChar = email.slice(0, skipFirstChars),
    domainIndexStart = email.lastIndexOf("@"),
    maskedEmail = email.slice(skipFirstChars, domainIndexStart),
    domain = email.slice(domainIndexStart, email.length);

  maskedEmail = maskedEmail.replace(/./g, "*");

  return firstThreeChar.concat(maskedEmail).concat(domain);
};

export const getMaskedNumber = (number) => {
  var USNumber = number.match(/(\d{3})(\d{3})(\d{4})/);

  USNumber = `(${USNumber[1]})-${USNumber[2]}-****`;
  return USNumber;
};

export const formatPhoneNumber = (phoneNumberString) => {
  // var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  // var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  var match = phoneNumberString.match(/^(1|)?(.{3})(.{3})(.{4})$/);
  if (match) {
    var intlCode = match[1] ? "+1 " : "";
    return [intlCode, "(", match[2], ")-", match[3], "-", match[4]].join("");
  }
  return null;
};

export const uuidv4 = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
};

export const throttle = (func, delay) => {
  // Previously called time of the function
  let prev = 0;
  return (...args) => {
    // Current called time of the function
    let now = new Date().getTime();
    // Logging the difference between previously
    // called and current called timings
    // console.log(now - prev, delay);
    // If difference is greater than delay call
    // the function again.
    if (now - prev > delay) {
      prev = now;
      // "..." is the spread operator here
      // returning the function with the
      // array of arguments
      return func(...args);
    }
  };
};

export const supportBtnContent = `
<div class="identity__row form-content active">
  <div class="identity__col-12">
    <div class="identity-alert__error" id="identity-alert__error" style="display:none;">
      <button data-close="close" style="display:none;" type="button">&times;</button>
      <svg class="icon" width="20px" height="20px" aria-hidden="true" role="img"><use href="#svg__alert-error" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg__alert-error"></use></svg>
      <div id="identity-alert__message" data-text="text"></div>
    </div>
  </div>
  <div class="identity__col-12 selfi-footer">
    <div class="identity__row column-reverse-xs">
      <div class="identity__col-12">
        <div class="identity-field">
          <button id="btn-support" type="button" class="identity-btn btn-continue">Continue</button>
        </div>
      </div>
    </div>
  </div>
</div>`;

export const getBaseUri = (uri) => {
  let a = document.createElement('a');
  a.href = uri;
  return a.host;
}

export const isMobile = ()=> {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

export const getLocalIP = () => {
  const pc = new RTCPeerConnection({ iceServers: [] });
  pc.createDataChannel('');
  pc.createOffer().then(offer => pc.setLocalDescription(offer));

  pc.onicecandidate = (event) => {
    if (!event.candidate) return;
    const ipRegex = /([0-9]{1,3}\.){3}[0-9]{1,3}/;
    const ipMatch = event.candidate.candidate.match(ipRegex);
    if (ipMatch == null)
    {
      setIpAddress("0.0.0.0");
      return "0.0.0.0"
    }
      
    if (ipMatch) {
      pc.close();
      setIpAddress(ipMatch[0]);
      return ipMatch[0]
    }
  };
}

export const getBrowserInfo = () => {
  const userAgent = navigator.userAgent;
  const platform = navigator.platform;
  const language = navigator.language;
  let browserName = "Unknown";
  let browserVersion = "Unknown";
  let operatingSystem = "Unknown";
  let deviceType = "Unknown";
  
  // Detect OS
  if (userAgent.indexOf("Win") > -1) operatingSystem = "Windows";
  else if (userAgent.indexOf("Mac") > -1) operatingSystem = "MacOS";
  else if (userAgent.indexOf("Linux") > -1) operatingSystem = "Linux";
  else if (userAgent.indexOf("Android") > -1) operatingSystem = "Android";
  else if (userAgent.indexOf("iPhone") > -1 || userAgent.indexOf("iPad") > -1) operatingSystem = "iOS";

  // Detect Device Type
  if (/mobile/i.test(userAgent)) {
    deviceType = "Mobile";
  }
  else if (/tablet/i.test(userAgent) || /iPad|Android/i.test(userAgent)) {
    deviceType = "Tablet";
  }
  else {
    deviceType = "Desktop";
  }

  setBrowserDetails({
    browserName: browserName,
    browserVersion: browserVersion,
    operatingSystem: operatingSystem,
    platform: platform,
    deviceType: deviceType,
    language: language,
    userAgent: userAgent
  });
}


